import { get } from 'lodash'
import styled from 'styled-components'

import Icon from '@/utilities/client-components/components/Icon/Icon'
import * as themeUtilities from '@/utilities/client-components/utilities/themeUtils'

// @ts-expect-error
const NotificationInteractionIndicator = styled(Icon).attrs(({ type }) => ({
  name: type === 'Action.OpenUrl' ? 'icon-external-link' : 'icon-chevron-right'
}))`
  position: absolute;
  top: 17px;
  right: 7px;
  width: 20px;
  height: 20px;
  transition-property: fill;
  transition-duration: 500ms;
  fill: ${(props: any) =>
    props.selected
      ? themeUtilities.getRgbaColor(props.theme, get(props.theme, `priority.${props.priority}.color`, 'dark'))
      : themeUtilities.getRgbaColor(props.theme, 'light')};
`

NotificationInteractionIndicator.displayName = 'NotificationInteractionIndicator'

export default NotificationInteractionIndicator
